/**
 * @generated SignedSource<<b6794f2b51e00e6a13d5cc7314551df1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Status_node$data = {
  readonly __typename: string;
  readonly cover?: boolean;
  readonly id: string;
  readonly isNew?: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"EditableFolderItemMenu_folderItemNode">;
  readonly " $fragmentType": "Status_node";
};
export type Status_node$key = {
  readonly " $data"?: Status_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"Status_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Status_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cover",
          "storageKey": null
        }
      ],
      "type": "VaultItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNew",
          "storageKey": null
        }
      ],
      "type": "IsNewInterface",
      "abstractKey": "__isIsNewInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditableFolderItemMenu_folderItemNode"
        }
      ],
      "type": "FolderNode",
      "abstractKey": "__isFolderNode"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "0d41e8f4e963a07ec6352d8f17457b69";

export default node;
